/* ==========================================================================
   Summit Financial — Theme JS
   Header scroll, mobile nav, counters, reveal, calculator, testimonials, faq
   ========================================================================== */
(function () {
  "use strict";

  /* ---------------- Header scroll effect ---------------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var transparentOnHero = header.getAttribute('data-transparent') === 'true';
    var threshold = 60;

    function update() {
      var scrolled = window.scrollY > threshold;
      header.classList.toggle('is-solid', scrolled);
      if (transparentOnHero) {
        header.classList.toggle('is-transparent-active', !scrolled);
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });

    // Mobile nav
    var burger = header.querySelector('[data-burger]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (burger && mobileNav) {
      var closeBtn = mobileNav.querySelector('[data-mobile-nav-close]');
      var backdrop = mobileNav.querySelector('[data-mobile-nav-backdrop]');
      function open() { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function close() { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
      burger.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);
    }
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-reveal-delay');
          if (delay) entry.target.style.transitionDelay = delay + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Animated counters ---------------- */
  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-counter-target'));
    var prefix = el.getAttribute('data-counter-prefix') || '';
    var suffix = el.getAttribute('data-counter-suffix') || '';
    var decimals = parseInt(el.getAttribute('data-counter-decimals') || '0', 10);
    var duration = 1800;
    var startTime = null;

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = prefix + value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-counter-target]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(animateCounter);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Progress bar reveal (hero dashboard) ---------------- */
  function initProgressBars() {
    var els = document.querySelectorAll('.dash__progress');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in-view'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      var wrap = item.querySelector('[data-faq-a-wrap]');
      if (!btn || !wrap) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherWrap = other.querySelector('[data-faq-a-wrap]');
          if (otherWrap) otherWrap.style.height = '0px';
          var otherBtn = other.querySelector('[data-faq-q]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          wrap.style.height = wrap.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------------- Testimonial carousel ---------------- */
  function initTestimonials() {
    var wraps = document.querySelectorAll('[data-testi-wrap]');
    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('[data-testi-track]');
      var cards = wrap.querySelectorAll('.testi-card');
      var prevBtn = wrap.querySelector('[data-testi-prev]');
      var nextBtn = wrap.querySelector('[data-testi-next]');
      if (!track || !cards.length) return;
      var perView = window.innerWidth >= 750 ? 2 : 1;
      var index = 0;
      var maxIndex = Math.max(0, cards.length - perView);

      function update() {
        perView = window.innerWidth >= 750 ? 2 : 1;
        maxIndex = Math.max(0, cards.length - perView);
        if (index > maxIndex) index = maxIndex;
        var cardWidth = cards[0].getBoundingClientRect().width;
        var gap = 24;
        track.style.transform = 'translateX(-' + (index * (cardWidth + gap)) + 'px)';
      }
      if (nextBtn) nextBtn.addEventListener('click', function () {
        index = index >= maxIndex ? 0 : index + 1;
        update();
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        index = index <= 0 ? maxIndex : index - 1;
        update();
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- Loan Calculator ---------------- */
  function initCalculator() {
    var calcs = document.querySelectorAll('[data-calculator]');
    calcs.forEach(function (calc) {
      var amountInput = calc.querySelector('[data-calc-amount]');
      var rateInput = calc.querySelector('[data-calc-rate]');
      var termInput = calc.querySelector('[data-calc-term]');
      var amountVal = calc.querySelector('[data-calc-amount-val]');
      var rateVal = calc.querySelector('[data-calc-rate-val]');
      var termVal = calc.querySelector('[data-calc-term-val]');
      var monthlyOut = calc.querySelector('[data-calc-monthly]');
      var interestOut = calc.querySelector('[data-calc-interest]');
      var totalOut = calc.querySelector('[data-calc-total]');
      if (!amountInput || !rateInput || !termInput) return;

      function fmt(n) {
        return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function calculate() {
        var principal = parseFloat(amountInput.value);
        var annualRate = parseFloat(rateInput.value);
        var years = parseFloat(termInput.value);
        var monthlyRate = annualRate / 100 / 12;
        var numPayments = years * 12;

        var monthly;
        if (monthlyRate === 0) {
          monthly = principal / numPayments;
        } else {
          monthly = principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments)) / (Math.pow(1 + monthlyRate, numPayments) - 1);
        }
        var total = monthly * numPayments;
        var interest = total - principal;

        if (amountVal) amountVal.textContent = fmt(principal);
        if (rateVal) rateVal.textContent = annualRate.toFixed(2) + '%';
        if (termVal) termVal.textContent = years + (years == 1 ? ' Year' : ' Years');
        if (monthlyOut) monthlyOut.textContent = fmt(monthly);
        if (interestOut) interestOut.textContent = fmt(interest);
        if (totalOut) totalOut.textContent = fmt(total);
      }

      [amountInput, rateInput, termInput].forEach(function (input) {
        input.addEventListener('input', calculate);
      });
      calculate();
    });
  }

  /* ---------------- Button ripple position tracking ---------------- */
  function initButtonRipple() {
    document.addEventListener('pointermove', function (e) {
      var btn = e.target.closest ? e.target.closest('.btn-ripple') : null;
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      btn.style.setProperty('--rx', ((e.clientX - rect.left) / rect.width * 100) + '%');
      btn.style.setProperty('--ry', ((e.clientY - rect.top) / rect.height * 100) + '%');
    });
  }

  /* ---------------- Hero particles ---------------- */
  function initParticles() {
    var containers = document.querySelectorAll('[data-particles]');
    containers.forEach(function (container) {
      var count = parseInt(container.getAttribute('data-particles') || '14', 10);
      for (var i = 0; i < count; i++) {
        var p = document.createElement('span');
        p.className = 'hero__particle';
        var size = Math.random() * 8 + 3;
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.left = Math.random() * 100 + '%';
        p.style.top = Math.random() * 100 + '%';
        p.style.animation = 'floatY ' + (Math.random() * 6 + 5) + 's ease-in-out infinite';
        p.style.animationDelay = (Math.random() * 4) + 's';
        p.style.opacity = (Math.random() * 0.5 + 0.3).toFixed(2);
        container.appendChild(p);
      }
    });
  }

  /* ---------------- Init on DOM ready ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initReveal();
    initCounters();
    initProgressBars();
    initFaq();
    initTestimonials();
    initCalculator();
    initButtonRipple();
    initParticles();
  });
})();
